import "../../design/loadingStyle.css";

export default function Loading() {
    return (
        <div className="loading-container academic-theme">
            {/* Elegant atmospheric overlays */}
            <div className="paper-texture"></div>
            <div className="soft-glow"></div>

            <div className="loader-content">
                <div className="scholar-spinner">
                    <div className="outer-ring"></div>
                    <div className="inner-orbit"></div>
                    <div className="core-point"></div>
                </div>

                <div className="loading-text-wrapper">
                    {/* Using the Georgian text provided */}
                    <p className="academic-loading-text">იტვირთება</p>
                    <div className="progress-line-container">
                        <div className="progress-line-fill"></div>
                    </div>
                </div>
            </div>
        </div>
    );
}